var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useRef, useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Fab from '@mui/material/Fab';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { BasicSelect, colorPalette } from '@next-common/mui';
import { RatingSummary } from '../Ratings';
import { ReviewComment } from '../ReviewComment';
import { SellerBio } from '../Seller';
import { DataForEshopSellerReviewDataApi } from '../../services/eshop-header-api/codegenClient';
import { useQuery } from '@tanstack/react-query';
export const EshopReview = ({ seller }) => {
    const [sortType, setSortType] = useState('RATE');
    const [sortOrder, setSortOrder] = useState('DESC');
    const [reviewQty, setReviewQty] = useState(0);
    const [nextToken, setNextToken] = useState();
    const [reviews, setReviews] = useState([]);
    const [hasMoreReview, setHasMoreReview] = useState(false);
    const ref = useRef(null);
    const Api = new DataForEshopSellerReviewDataApi(undefined, '');
    const { refetch, isLoading } = useQuery({
        queryKey: ['getEshopSellerReviewData', sortType, sortOrder],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c;
            if (seller === null || seller === void 0 ? void 0 : seller.id) {
                const result = yield Api.getEshopSellerReviewData(((_a = seller === null || seller === void 0 ? void 0 : seller.id) === null || _a === void 0 ? void 0 : _a.toString()) || '', sortType, sortOrder, 20, nextToken || undefined);
                if (!((_b = result === null || result === void 0 ? void 0 : result.data) === null || _b === void 0 ? void 0 : _b.nextToken)) {
                    setHasMoreReview(false);
                    setNextToken(undefined);
                }
                else {
                    setHasMoreReview(true);
                    setNextToken(result === null || result === void 0 ? void 0 : result.data.nextToken);
                }
                const res = [...(reviews || []), ...(((_c = result === null || result === void 0 ? void 0 : result.data) === null || _c === void 0 ? void 0 : _c.ratings) || [])];
                setReviewQty(res.length);
                setReviews(res);
                return result;
            }
        }),
        refetchOnMount: false,
    });
    useEffect(() => {
        if ((reviews === null || reviews === void 0 ? void 0 : reviews.length) === 0) {
            refetch().then((res) => {
                var _a;
                setReviews((_a = res.data) === null || _a === void 0 ? void 0 : _a.data.ratings);
            });
        }
    }, [seller === null || seller === void 0 ? void 0 : seller.id, reviews, refetch]);
    const handleChangeFilter = (event) => __awaiter(void 0, void 0, void 0, function* () {
        var _d;
        setNextToken(undefined);
        setReviews(undefined);
        switch (event.target.value) {
            case 'CREATION_DATE_DESC':
                setSortType('CREATION_DATE');
                setSortOrder('DESC');
                break;
            case 'CREATION_DATE_ASC':
                setSortOrder('ASC');
                setSortType('CREATION_DATE');
                break;
            case 'RATE_DESC':
                setSortType('RATE');
                setSortOrder('DESC');
                break;
            case 'RATE_ASC':
                setSortType('RATE');
                setSortOrder('ASC');
                break;
            default:
                break;
        }
        setReviewQty(20);
        setReviews((_d = (yield refetch()).data) === null || _d === void 0 ? void 0 : _d.data.ratings);
    });
    const handleLoadMore = () => {
        if (hasMoreReview) {
            refetch();
        }
    };
    const sortsOptions = [
        {
            value: 'CREATION_DATE_DESC',
            label: 'Les plus récents',
        },
        {
            value: 'CREATION_DATE_ASC',
            label: 'Les plus anciens',
        },
        {
            value: 'RATE_DESC',
            label: 'Les meilleures notes',
        },
        {
            value: 'RATE_ASC',
            label: 'Les moins bonnes notes',
        },
    ];
    const scrollToTop = () => {
        if (ref && ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    };
    return (React.createElement(Stack, { component: "div", ref: ref, spacing: 2 },
        React.createElement(Stack, { component: "div", sx: {
                borderBottom: `8px solid ${colorPalette.gray100}`,
            } },
            React.createElement(SellerBio, { seller: seller }),
            React.createElement(Stack, { direction: "row", padding: "16px 0", justifyContent: "center", alignItems: "center", spacing: 3 },
                React.createElement(RatingSummary, { numberOfSales: seller === null || seller === void 0 ? void 0 : seller.numberOfSale, sellerRating: seller === null || seller === void 0 ? void 0 : seller.sellerRating }))),
        React.createElement(Stack, { alignItems: "center", justifyContent: "center" },
            React.createElement(Box, { width: "100%" },
                React.createElement(BasicSelect, { label: "Trier par", onChange: handleChangeFilter, sx: {
                        width: '100%',
                    }, MenuProps: {
                        MenuListProps: {
                            container: () => {
                                const id = 'hpernova-class-wrapper';
                                const hpernovaClassWrapper = document.getElementById(id);
                                if (hpernovaClassWrapper) {
                                    return hpernovaClassWrapper;
                                }
                                const elemDiv = document.createElement('div');
                                elemDiv.classList.add('_hy');
                                elemDiv.id = id;
                                document.body.appendChild(elemDiv);
                                return elemDiv;
                            },
                        },
                    } }, sortsOptions.map((sort, i) => (React.createElement(MenuItem, { key: i, value: sort.value }, sort.label)))))),
        isLoading && (reviews === null || reviews === void 0 ? void 0 : reviews.length) === 0 ? (React.createElement(Stack, { width: "100%", justfiContent: "center", alignItems: "center" },
            React.createElement(CircularProgress, null))) : (reviews === null || reviews === void 0 ? void 0 : reviews.map((rating, i) => {
            return React.createElement(ReviewComment, Object.assign({ key: i }, rating, { isLoading: isLoading }));
        })),
        React.createElement(Stack, { alignItems: "center", justifyContent: "center", padding: "16px", paddingBottom: "40px", spacing: 2 },
            React.createElement(Typography, { sx: {
                    fontSize: '14px',
                    color: colorPalette.gray700,
                } },
                reviewQty,
                "\u2002avis"),
            React.createElement(Button, { variant: "text", color: "secondary", disabled: !hasMoreReview, onClick: handleLoadMore }, "Charger plus d'avis +")),
        React.createElement(Fab, { sx: {
                position: 'absolute',
                bottom: 16,
                right: 16,
                backgroundColor: 'white',
                boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.14), 0px 2px 2px 0px rgba(0, 0, 0, 0.12);',
            }, onClick: scrollToTop },
            React.createElement(ArrowUpwardIcon, null))));
};
